var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGTranslate = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    display: "block"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "g_translate_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h18v18H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#g_translate_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5l-.75-2.25H3c-.412 0-.765-.147-1.06-.44a1.445 1.445 0 01-.44-1.06V3c0-.413.147-.766.44-1.06.295-.293.648-.44 1.06-.44h4.5l.656 2.25H15c.438 0 .797.14 1.078.422.282.281.422.64.422 1.078V15c0 .412-.14.766-.422 1.06-.28.293-.64.44-1.078.44H9zm-3.637-5.55c.862 0 1.572-.278 2.128-.834.556-.557.834-1.279.834-2.166 0-.1-.003-.19-.01-.272a1.28 1.28 0 00-.046-.253H5.306v1.162h1.67c-.1.35-.291.622-.573.816-.28.194-.622.29-1.022.29-.487 0-.906-.174-1.256-.524A1.758 1.758 0 013.6 7.875c0-.513.175-.944.525-1.294.35-.35.769-.525 1.256-.525a1.636 1.636 0 011.181.487l.92-.88a2.694 2.694 0 00-.947-.638A3.08 3.08 0 005.363 4.8c-.838 0-1.553.297-2.147.89-.594.594-.89 1.322-.89 2.185 0 .862.296 1.59.89 2.184.594.594 1.31.891 2.147.891zm5.025.375l.412-.394a10.235 10.235 0 01-.9-1.256l.488 1.65zm.937-.956a5.69 5.69 0 00.797-1.182c.181-.375.303-.668.366-.88H9.506l.225.787h.75c.1.187.22.39.357.61.137.218.3.44.487.665zM9.75 15.75H15a.718.718 0 00.544-.216.743.743 0 00.206-.534V5.25a.735.735 0 00-.206-.544A.735.735 0 0015 4.5H8.381l.882 3.037h1.48V6.75h.77v.787h2.737v.77h-.956a5.989 5.989 0 01-.563 1.387c-.25.45-.543.868-.88 1.256l2.043 2.006-.544.544-2.025-2.025-.675.694.6 2.081-1.5 1.5z",
    fill: "#0645B1"
  }))));
};
export default SvgGTranslate;